import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
import momentEU from 'moment/locale/eu'

import dashboard from './en-US/dashboard'

const components = {
  antLocale: antdEnUS,
  momentName: 'eu',
  momentLocale: momentEU
}

export default {
  message: '-',
  ...components,
  ...dashboard
}



// WEBPACK FOOTER //
// ./src/locales/lang/en-US.js